
import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";
import apiUrl from "../../environment/Api";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import Select from "react-select";
import styled from "styled-components";
import ActionsDropdown from "../ActionsDropdown";
import {
  useTable,
  useFilters,
  useGlobalFilter,
  useSortBy,
  usePagination,
} from "react-table";
import { createPortal } from "react-dom";





const TableContainer = styled.div`
  padding: 20px;
  overflow-x: auto;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ddd;

  // Apply striped rows styling
  tr:nth-child(odd) {
    background-color: #f2f2f2; /* Light gray for even rows */
  }

  tr:nth-child(even) {
    background-color: #ffffff; /* White for odd rows */
  }
`;

const Th = styled.th`
  padding: 10px;
  background-color: #fff;
  text-align: left;
  cursor: pointer;
  position: relative;
`;

const Td = styled.td`
  padding: 10px;
  // border: 1px solid #ddd;
`;

function GlobalFilter({ globalFilter, setGlobalFilter }) {
  return (
    <div style={{ marginBottom: "10px" }}>
      <input
        value={globalFilter || ""}
        onChange={(e) => setGlobalFilter(e.target.value)}
        placeholder="Search all columns..."
        style={{
          padding: "5px",
          border: "1px solid #ddd",
          borderRadius: "4px",
          width: "100%",
        }}
      />
    </div>
  );
}
// Default Column Filter (Icon-based)
const DefaultColumnFilter = ({
  column: { filterValue, setFilter, preFilteredRows, id },
}) => {
  const [isActive, setIsActive] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);
  const options = useMemo(() => {
    const uniqueValues = Array.from(
      new Set(preFilteredRows.map((row) => row.values[id]))
    ).map((value) => ({ label: value, value }));
    return [{ label: "All", value: "" }, ...uniqueValues];
  }, [id, preFilteredRows]);

  // Handle icon click
  const handleIconClick = () => {
    setIsActive(!isActive);
  };

  const handleMultiSelectChange = (selectedOptions) => {
    const values = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setFilter(values.length > 0 ? values : undefined);
  };

  return (
    <div style={{ alignItems: "center" }}>
      <div>
        <i
          className="fa-solid fa-ellipsis-vertical"
          onClick={handleIconClick}
          style={{
            cursor: "pointer",
            fontSize: "20px",
            color: "#AC0000",
          }}
        ></i>
      </div>
      <div>
        {isActive &&
          createPortal(
            <div
              style={{
                position: "fixed",
                zIndex: 9999,
                left: "50%",
                top: "50%",
                width: "30%",
                transform: "translate(-50%, -50%)",
              }}
            >
              <div
                style={{
                  position: "relative",
                  background: "white",
                  padding: "20px",
                  borderRadius: "8px",
                  boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                  backgroundColor: "#A70000",
                }}
              >
                <Select
                  options={options}
                  isMulti
                  value={options.filter((option) =>
                    filterValue?.includes(option.value)
                  )}
                  onChange={handleMultiSelectChange}
                  isClearable
                  isSearchable
                  placeholder={`Filter ${id}`}
                  styles={{
                    menu: (provided) => ({
                      ...provided,
                      zIndex: 9999,
                    }),
                  }}
                />
                <button
                  style={{
                    marginTop: "10px",
                    marginLeft: "150px",
                    padding: "5px 10px",
                    background: "#007bff",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                  onClick={() => setIsActive(false)} // Close the popup
                >
                  Close
                </button>
              </div>
            </div>,
            document.body
          )}
      </div>
    </div>
  );
};



function Branch() {
  const [responseData, setResponseData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isUpdateshowModal, setUpdateShowModal] = useState(false);
  const [previewShowModal, setpreviewShowModal] = useState(false);
  const [role_id, setroleid] = useState("");

  const [previllages, setprevillages] = useState({});

  const [addData, setAddData] = useState({
    ad4branch_id: "",
    branch_name: "",
    status: "",
    address: "",
    phone_no: "",
    email_id: "",
  });

  const [updateData, setUpdateData] = useState({
    branch_id: "",
    branch_name: "",
    status: "",
    address: "",
    phone_no: "",
    email_id: "",
  });

  useEffect(() => {
    fetchData();
    gettoken();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(apiUrl + "/Branch", {
        params: { data: localStorage.getItem("branch_id") },
      });
      console.log("Response from server:", response.data);
      if (response && response.status === 200) {
        setTimeout(() => {
          setLoading(false);
        }, 300);
      }
      setResponseData(response.data.reverse());
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };



  const gettoken = async () => {
    const token = localStorage.getItem("token");
    // console.log("the toekn in the localStorage is : ",token);
    try {
      const response = await axios.post(apiUrl + "/get_detail", {
        token: token,
      });
      console.log("token detail from server:", response.data);
      // setResponseData(response.data);

      console.log("The role id is : ", response.data.detail.rolename);
      setroleid(response.data.detail.rolename);
      console.log("the role_id is : ", role_id);

      localStorage.setItem("role_id", response.data.detail.rolename);

      const id = response.data.detail.rolename;

      // getpages();

      if (id) {
        try {
          const response = await axios.get(apiUrl + `/role_2/${id}`);

          console.log("the reponse list in brach is : ", response.data.modules);

          const modules = response.data.modules;

          const filtered_access = modules.filter(
            (item) => item.name == "Branch"
          );

          console.log("the modules is : ", filtered_access[0].actions);

          setprevillages(filtered_access[0].actions);

          console.log("the assigned previllages isaaaa : ", previllages.add);
          console.log("the assigned previllages isaaaa : ", previllages.edit);
          console.log("the assigned previllages isaaaa : ", previllages.delete);
        } catch (error) {
          console.error("Error fetching data:", error.message);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };



  const handlesubmit = async (e) => {
    e.preventDefault();

    if (!validateFields()) {
      return;
    }
    try {
      setLoading(true);
      const formData = {
        branch_id: addData.branch_id,
        branch_name: addData.branch_name,
        status: addData.status,
        address: addData.address,
        phone_no: addData.phone_no,
        email_id: addData.email_id,
      };
      const response = await axios.post(apiUrl + "/Branch", formData);
      console.log("Updated:", response);
      setShowModal(false);
      toast.success("added successfully!");
      setAddData({
        name: "",
      });
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      fetchData();
    } catch (error) {
      console.error("Error updating data:", error.message);
    }
  };


  const [updateid, setUpdateId] = useState("");

  const handleUpdate = (_id, data) => {
    if (previllages.edit || previllages.all) {
      setUpdateId(_id);
      console.log(" the data to updata", data);
      setUpdateShowModal(true);
      setUpdateData({
        branch_id: data.branch_id,
        branch_name: data.branch_name,
        status: data.status,
        address: data.address,
        phone_no: data.phone_no,
        email_id: data.email_id,
      });
    } else {
      toast.error("You don't have the permission");
    }
  };



  const handlepreview = (_id, data) => {
    if (previllages.edit || previllages.all) {
      setUpdateId(_id);
      console.log(" the data to updata", data);
      setpreviewShowModal(true);
      setUpdateData({
        branch_id: data.branch_id,
        branch_name: data.branch_name,
        status: data.status,
        address: data.address,
        phone_no: data.phone_no,
        email_id: data.email_id,
      });
    } else {
      toast.error("You don't have the permission");
    }
  };



  const handleupdatesubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const formData = {
        branch_id: updateData.branch_id,
        branch_name: updateData.branch_name,
        status: updateData.status,
        address: updateData.address,
        phone_no: updateData.phone_no,
        email_id: updateData.email_id,
      };
      console.log("the update submit data", formData);
      const response = await axios.put(
        apiUrl + `/Branch/${updateid}`,
        formData
      );
      console.log("response for update", response);
      setUpdateShowModal(false);
      toast.success("Update successfully!");
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      fetchData();
    } catch (error) {
      console.error("Error updating data:", error.message);
    }
  };

  const handleDelete = async (id) => {
    try {
      setLoading(true);
      const response = await axios.delete(apiUrl + `/Branch/${getdeleteid}`);
      console.log("delete data ", response);
      toast.error("Delete successfully!");
      setDeleteShowModals(false);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      fetchData();
    } catch (error) {
      console.error("Error updating data:", error.message);
    }
  };

  const [deleteShowModals, setDeleteShowModals] = useState(false);
  const handleCloseModal = () => {
    setDeleteShowModals(false);
  };

  const [getdeleteid, setdeleteid] = useState("");
  const [getdeletename, setdeletename] = useState("");

  const handleOpenModal = (_id, branch_name) => {
    if (previllages.all || previllages.delete) {
      console.log(" the id", _id);
      console.log(" the name", branch_name);
      setdeleteid(_id);
      setdeletename(branch_name);
      setDeleteShowModals(true);
    } else {
      toast.error("You don't have the permission");
    }
  };

  // the pagination ---------------------------------------------------------------------
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = responseData.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Search
  const filtered = currentItems.filter((item) =>
    Object.values(item).some(
      (value) =>
        (typeof value === "string" &&
          value.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (typeof value === "number" && value.toString().includes(searchQuery))
    )
  );

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1);
  };

  const totalPages = Math.ceil(responseData.length / itemsPerPage);

  const goToNextPage = () => {
    setCurrentPage((prevPage) =>
      prevPage === totalPages ? prevPage : prevPage + 1
    );
  };

  const goToPrevPage = () => {
    setCurrentPage((prevPage) => (prevPage === 1 ? prevPage : prevPage - 1));
  };
  // the pagination  end ---------------------------------------------------------------------

  // const createPagination = () => {
  //   let liTag = [];
  //   let totalPages = pageCount; // Total pages
  //   let currentPage = state.pageIndex;
  //   let active;

  //   // Previous Page Button
  //   liTag.push(
  //     <li className={`page-item ${!canPreviousPage ? "disabled" : ""}`} key="prev">
  //       <button
  //         className="page-link"
  //         onClick={() => gotoPage(currentPage - 1)}
  //         disabled={!canPreviousPage}
  //       >
  //         <FaAngleLeft /> Prev
  //       </button>
  //     </li>
  //   );

  //   // Always show first page
  //   if (totalPages > 1) {
  //     liTag.push(
  //       <li className={`page-item ${currentPage === 0 ? "active" : ""}`} key={0}>
  //         <button className="page-link" onClick={() => gotoPage(0)}>
  //           1
  //         </button>
  //       </li>
  //     );
  //   }

  //   // Show second page if total pages > 2
  //   if (totalPages > 2) {
  //     liTag.push(
  //       <li className={`page-item ${currentPage === 1 ? "active" : ""}`} key={1}>
  //         <button className="page-link" onClick={() => gotoPage(1)}>
  //           2
  //         </button>
  //       </li>
  //     );
  //   }

  //   // Add "..." before current page group
  //   if (currentPage > 3) {
  //     liTag.push(
  //       <li className="page-item disabled" key="dot-prev">
  //         <span className="page-link">...</span>
  //       </li>
  //     );
  //   }

  //   // Show 3 pages around current page
  //   for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 3, currentPage + 1); i++) {
  //     active = currentPage === i ? "active" : "";
  //     liTag.push(
  //       <li className={`page-item ${active}`} key={i}>
  //         <button className="page-link" onClick={() => gotoPage(i)}>
  //           {i + 1}
  //         </button>
  //       </li>
  //     );
  //   }

  //   // Add "..." after current page group
  //   if (currentPage < totalPages - 4) {
  //     liTag.push(
  //       <li className="page-item disabled" key="dot-next">
  //         <span className="page-link">...</span>
  //       </li>
  //     );
  //   }

  //   // Always show last two pages if totalPages > 2
  //   if (totalPages > 2) {
  //     liTag.push(
  //       <li className={`page-item ${currentPage === totalPages - 2 ? "active" : ""}`} key={totalPages - 2}>
  //         <button className="page-link" onClick={() => gotoPage(totalPages - 2)}>
  //           {totalPages - 1}
  //         </button>
  //       </li>
  //     );
  //   }

  //   if (totalPages > 1) {
  //     liTag.push(
  //       <li className={`page-item ${currentPage === totalPages - 1 ? "active" : ""}`} key={totalPages - 1}>
  //         <button className="page-link" onClick={() => gotoPage(totalPages - 1)}>
  //           {totalPages}
  //         </button>
  //       </li>
  //     );
  //   }

  //   // Next Page Button
  //   liTag.push(
  //     <li className={`page-item ${!canNextPage ? "disabled" : ""}`} key="next">
  //       <button
  //         className="page-link"
  //         onClick={() => gotoPage(currentPage + 1)}
  //         disabled={!canNextPage}
  //       >
  //         Next <FaAngleRight />
  //       </button>
  //     </li>
  //   );

  //   return liTag;
  // };


  const createPagination = () => {
    let liTag = [];
    let totalPages = pageCount; // Total pages
    let currentPage = state.pageIndex;
    let active;

    // Previous Page Button
    liTag.push(
      <li className={`page-item ${!canPreviousPage ? "disabled" : ""}`} key="prev">
        <button
          className="page-link"
          onClick={() => gotoPage(currentPage - 1)}
          disabled={!canPreviousPage}
        >
          <FaAngleLeft /> Prev
        </button>
      </li>
    );

    // Always show first page
    if (totalPages > 1) {
      liTag.push(
        <li className={`page-item ${currentPage === 0 ? "active" : ""}`} key={0}>
          <button className="page-link" onClick={() => gotoPage(0)}>
            1
          </button>
        </li>
      );
    }

    // Show second page if total pages > 2
    if (totalPages > 2) {
      liTag.push(
        <li className={`page-item ${currentPage === 1 ? "active" : ""}`} key={1}>
          <button className="page-link" onClick={() => gotoPage(1)}>
            2
          </button>
        </li>
      );
    }

    // Add "..." before current page group
    if (currentPage > 3) {
      liTag.push(
        <li className="page-item disabled" key="dot-prev">
          <span className="page-link">...</span>
        </li>
      );
    }

    // Show 3 pages around current page
    for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 3, currentPage + 1); i++) {
      active = currentPage === i ? "active" : "";
      liTag.push(
        <li className={`page-item ${active}`} key={i}>
          <button className="page-link" onClick={() => gotoPage(i)}>
            {i + 1}
          </button>
        </li>
      );
    }

    // Add "..." after current page group
    if (currentPage < totalPages - 4) {
      liTag.push(
        <li className="page-item disabled" key="dot-next">
          <span className="page-link">...</span>
        </li>
      );
    }

    // Always show last two pages if totalPages > 2
    if (totalPages > 2) {
      liTag.push(
        <li className={`page-item ${currentPage === totalPages - 2 ? "active" : ""}`} key={totalPages - 2}>
          <button className="page-link" onClick={() => gotoPage(totalPages - 2)}>
            {totalPages - 1}
          </button>
        </li>
      );
    }

    if (totalPages > 1) {
      liTag.push(
        <li className={`page-item ${currentPage === totalPages - 1 ? "active" : ""}`} key={totalPages - 1}>
          <button className="page-link" onClick={() => gotoPage(totalPages - 1)}>
            {totalPages}
          </button>
        </li>
      );
    }

    // Next Page Button
    liTag.push(
      <li className={`page-item ${!canNextPage ? "disabled" : ""}`} key="next">
        <button
          className="page-link"
          onClick={() => gotoPage(currentPage + 1)}
          disabled={!canNextPage}
        >
          Next <FaAngleRight />
        </button>
      </li>
    );

    return liTag;
  };

  // ================================================================
  const [errors, setErrors] = useState({});

  const validateFields = () => {
    let tempErrors = {};
    let isValid = true;

    if (!addData.branch_id) {
      tempErrors.branch_id = "Branch code is required.";
      isValid = false;
    }

    if (!addData.branch_name) {
      tempErrors.branch_name = "Branch Name is required.";
      isValid = false;
    }

    if (!addData.status) {
      tempErrors.status = "Status is required.";
      isValid = false;
    }

    setErrors(tempErrors);
    return isValid;
  };

  const [loading, setLoading] = useState(false);

  const data = useMemo(() => {
    return responseData.map((item) => ({
      _id: item._id,
      branch_id: item.branch_id,
      branch_name: item.branch_name,
      status: item.status,
      address: item.address,
      email_id: item.email_id,
      phone_no: item.phone_no,
    }));
  }, [responseData]);

  const columns = useMemo(
    () => [
      {
        Header: "S.No",
        id: "serialNo",
        Cell: ({ row }) => {
          return row.index + 1;
        },
      },
      {
        Header: "Branch Code",
        accessor: "branch_id",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      {
        Header: "Branch Name",
        accessor: "branch_name",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      {
        Header: "Mobile",
        accessor: "phone_no",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      {
        Header: "Status",
        accessor: "status",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
        Cell: ({ value }) => {
          // Conditional logic for the status
          if (value === "Active") {
            return (
              <td className="text-center hideres">
                <p className="text-white green-label">{value}</p>
              </td>
            );
          } else {
            return (
              <td className="text-center hideres">
                <p className="text-white red-label">{value}</p>
              </td>
            );
          }
        },
      },

    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state,
    setGlobalFilter,
    setPageSize,
    page,
    canPreviousPage,
    canNextPage,
    pageCount,
    gotoPage,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageSize: 10 },
      defaultColumn: { Filter: DefaultColumnFilter },
      filterTypes: {
        multiSelectFilter: (rows, columnIds, filterValue) => {
          if (!filterValue || filterValue.length === 0) {
            return rows;
          }
          return rows.filter((row) => {
            const rowValue = row.values[columnIds[0]];
            const rowValueStr = String(rowValue);
            return filterValue.some((filterVal) =>
              rowValueStr.includes(String(filterVal))
            );
          });
        },
      },
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination
  );



  return (
    <>
      {loading === true ? (
        <div className="loading-overlay">
          <div className="loading-message">
            <img
              className="loadinggif"
              src={require("../../assets/img/output-onlinegiftools.gif")}
            />{" "}
          </div>
        </div>
      ) : (
        <div className="d-none"></div>
      )}

      <div className="top">
        <div className="" style={{ marginTop: "-80px" }}>
          <div className="row mb-3">
            <div className="col-lg-11">
              <Link to="/dashboard" className="text-secondary dashBoard_text">
                <b>Dashboard / </b>
              </Link>
              <Link to="" className="text-danger dashBoard_text">
                <b>Branch</b>
              </Link>
              {/* <Link to="" className="text-danger dashBoard_text">
                            <b>Profile</b>
                        </Link> */}
            </div>
          </div>
        </div>
        {/* Table */}


        {/* ------------ search and per page ----------------------------*/}

        <div className="mb-1 mt-3">
          <div className="row">
            <div className="col-lg-7 col-md-4 col-sm-1">
              <div className="d-flex">
                <h5 className="mt-2">Branch</h5>
                <div className="mx-3">
                  {previllages.add && (
                    <button
                      className="btn btn-success add "
                      style={{ backgroundColor: "#ffc107", color: "black" }}
                      onClick={() => setShowModal(true)}
                    >
                      Add
                    </button>
                  )}
                </div>
              </div>
            </div>
            <div className="col-lg-5 col-md-4 col-sm-4 d-flex justify-content-end">
              {/* </div>

            <div className="col-lg-3 col-md-4 col-sm-7"> */}
              <div className="w-full flex-1 me-5">
                <form>
                  <div className="relative">
                    <input
                      className="form-control w-full bg-white appearance-none pl-8 dark:bg-gray-950"
                      style={{
                        outline: 'none',
                        boxShadow: 'none'
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = '#ffc107';
                        e.target.style.boxShadow = '0 0 0 0.2rem rgba(253, 179, 4, 0.25)';
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = '#ced4da';
                        e.target.style.boxShadow = 'none';
                      }}
                      placeholder="Search ..."
                      type="search"
                      value={state.globalFilter || ""}
                      onChange={(e) => setGlobalFilter(e.target.value)}
                    />
                  </div>
                </form>
              </div>
              <div className="d-flex me-2">
                <label className="form-label text-dark mt-1">Show : </label>
                <div>
                  <select
                    className="form-control w-100 mx-2"
                    value={state.pageSize}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === 'All') {
                        setPageSize(data.length);  // 'data' should be your dataset containing all the entries
                      } else {
                        setPageSize(Number(value));
                      }
                    }}
                  >
                    <option value="All">All</option> {/* Add 'All' option */}
                    {[10, 20, 100, 200, 500, 1000].map((pageSize) => (
                      <option key={pageSize} value={pageSize}>
                        {pageSize}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>



        {/* --------------------------------end------------------------------------------- */}
        {/* <div className="card">
          <div className="mt-1">
            <table className="table table-striped ">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Branch Code</th>
                  <th>Branch Name</th>
                  <th>Address</th>
                  <th>Mobile No</th>
                  <th>Email ID</th>
                  <th>Status</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>

              <tbody>
                {filtered.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item.branch_id}</td>
                    <td>{item.branch_name}</td>
                    <td>{item.address}</td>
                    <td>{item.phone_no}</td>
                    <td>{item.email_id}</td>

                    {item.status == "Active" ? (
                      <td className="text-center hideres ">
                        <p className=" text-white green-label">{item.status}</p>
                      </td>
                    ) : (
                      <td className="text-center hideres">
                        <p className="text-white red-label">{item.status}</p>
                      </td>
                    )}

                    <td className="text-center">
                    

                      {previllages.edit && (
                        <button
                          className="btn updelete mx-2"
                          onClick={() => handleUpdate(item._id, item)}
                        >
                          <i className="fa-solid fa-pen-to-square"></i>
                        </button>
                      )}

                      {previllages.delete && (
                        <button
                          className="btn delete"
                          onClick={() =>
                            handleOpenModal(item._id, item.branch_name)
                          }
                        >
                          <i className="fa-solid fa-trash-can"></i>
                        </button>
                      )}
                      <button
                        className="btn updelete mx-2"
                        onClick={() => handlepreview(item._id, item)}
                      >
                        <i className="fa-solid fa-circle-info"></i>
                      </button>

                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div> */}

        <Table {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <Th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                  >
                    <div className="d-flex">
                      <div className="mx-2">{column.render("Header")}</div>
                      <div>
                        {column.canFilter ? column.render("Filter") : null}
                      </div>
                      <div className="mx-1">
                        {column.isSorted
                          ? column.isSortedDesc
                            ? " 🔽"
                            : " 🔼"
                          : ""}
                      </div>
                    </div>
                  </Th>
                ))}
                <Th className="text-center">Action</Th>
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => (
                    <Td {...cell.getCellProps()}>{cell.render("Cell")}</Td>
                  ))}

                  <Td className="text-center">
                    <ActionsDropdown
                      row={row.original}
                      permissions={previllages}
                      onEdit={(id, row) =>
                        handleUpdate(id, row)
                      }
                      onDelete={(id, row) =>
                        handleOpenModal(id, row.branch_name)
                      }
                      onInfo={(id, row) =>
                        handlepreview(id, row)
                      }
                    />
                  </Td>
                </tr>
              );
            })}
          </tbody>
        </Table>


        {/* Modal for adding a new user */}
        {/* <Modal show={showModal} onHide={() => setShowModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title id="modeti">Add Branch </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form-group">
              <div className="floating-label">
                <input
                  className="form-control"
                  type="text"
                  placeholder=""
                  value={addData.branch_id}
                  onChange={(e) =>
                    setAddData({ ...addData, branch_id: e.target.value })
                  }
                  required
                />
                <label className={addData.branch_id ? "filled" : ""}>
                  Branch Code
                </label>
                {errors.branch_id && (
                  <div className="error-text">{errors.branch_id}</div>
                )}
              </div>

              <div className="floating-label">
                <input
                  className="form-control"
                  type="text"
                  placeholder=""
                  value={addData.branch_name}
                  onChange={(e) =>
                    setAddData({ ...addData, branch_name: e.target.value })
                  }
                  required
                />
                <label className={addData.branch_name ? "filled" : ""}>
                  Branch Name
                </label>
                {errors.branch_name && (
                  <div className="error-text">{errors.branch_name}</div>
                )}
              </div>

              <div className="floating-label">
                <input
                  className="form-control"
                  type="text"
                  placeholder=""
                  value={addData.address}
                  onChange={(e) =>
                    setAddData({ ...addData, address: e.target.value })
                  }
                  required
                />
                <label className={addData.address ? "filled" : ""}>
                  Address
                </label>
              </div>

              <div className="floating-label">
                <input
                  className="form-control"
                  type="tel"
                  placeholder=""
                  value={addData.phone_no}
                  onChange={(e) =>
                    setAddData({ ...addData, phone_no: e.target.value })
                  }
                  required
                />
                <label className={addData.phone_no ? "filled" : ""}>
                  Phone No
                </label>
              </div>

              <div className="floating-label">
                <input
                  className="form-control"
                  type="text"
                  placeholder=""
                  value={addData.email_id}
                  onChange={(e) =>
                    setAddData({ ...addData, email_id: e.target.value })
                  }
                  required
                />
                <label className={addData.email_id ? "filled" : ""}>
                  Email ID
                </label>
              </div> */}

        {/* Status Select Dropdown */}
        {/* <div className="floating-label">
                <select
                  className="form-control"
                  value={addData.status}
                  placeholder="Select status"
                  onChange={(e) =>
                    setAddData({ ...addData, status: e.target.value })
                  }
                >
                  <option value="">Select Status</option>
                  <option value="Active">Active</option>
                  <option value="InActive">InActive</option>
                </select>
                <label className={addData.status ? "filled" : ""}>
                  Select Status
                </label>
                {errors.status && (
                  <div className="error-text">{errors.status}</div>
                )}
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              className="cancelbut"
              variant="secondary"
              onClick={() => setShowModal(false)}
            >
              Cancel
            </Button>
            <Button
              className="submitbut"
              variant="primary"
              onClick={handlesubmit}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal> */}

        <Modal
          show={isUpdateshowModal}
          onHide={() => setUpdateShowModal(false)}
        >
          <Modal.Header closeButton>
            <Modal.Title id="modeti">Update Branch</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* Other input fields */}

            <div className="form-group">
              <div className="floating-label">
                <input
                  className="form-control"
                  type="text"
                  placeholder=""
                  value={updateData.branch_id}
                  onChange={(e) =>
                    setUpdateData({ ...updateData, branch_id: e.target.value })
                  }
                  required
                />
                <label className={updateData.branch_id ? "filled" : ""}>
                  Branch Code
                </label>
              </div>

              <div className="floating-label">
                <input
                  className="form-control"
                  type="text"
                  placeholder=""
                  value={updateData.branch_name}
                  onChange={(e) =>
                    setUpdateData({
                      ...updateData,
                      branch_name: e.target.value,
                    })
                  }
                  required
                />
                <label className={updateData.branch_name ? "filled" : ""}>
                  Branch Name
                </label>
              </div>

              <div className="floating-label">
                <input
                  className="form-control"
                  type="text"
                  placeholder=""
                  value={updateData.address}
                  onChange={(e) =>
                    setUpdateData({ ...updateData, address: e.target.value })
                  }
                  required
                />
                <label className={updateData.address ? "filled" : ""}>
                  Address
                </label>
              </div>

              <div className="floating-label">
                <input
                  className="form-control"
                  type="tel"
                  placeholder=""
                  value={updateData.phone_no}
                  onChange={(e) =>
                    setUpdateData({ ...updateData, phone_no: e.target.value })
                  }
                  required
                />
                <label className={updateData.phone_no ? "filled" : ""}>
                  Mobile No
                </label>
              </div>

              <div className="floating-label">
                <input
                  className="form-control"
                  type="email"
                  placeholder=""
                  value={updateData.email_id}
                  onChange={(e) =>
                    setUpdateData({ ...updateData, email_id: e.target.value })
                  }
                  required
                />
                <label className={updateData.email_id ? "filled" : ""}>
                  Email ID
                </label>
              </div>

              <div className="floating-label">
                <select
                  className="form-control"
                  value={updateData.status}
                  onChange={(e) =>
                    setUpdateData({ ...updateData, status: e.target.value })
                  }
                >
                  <option value="">Select Status</option>
                  <option value="Active">Active</option>
                  <option value="InActive">InActive</option>
                </select>
                <label className={updateData.status ? "filled" : ""}>
                  Select Status
                </label>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              className="cancelbut"
              variant="secondary"
              onClick={() => setUpdateShowModal(false)}
            >
              Cancel
            </Button>
            <Button
              className="submitbut"
              variant="primary"
              onClick={handleupdatesubmit}
            >
              Update
            </Button>
          </Modal.Footer>
        </Modal>

        {/* ----------------delete */}

        <Modal show={showModal} onHide={() => setShowModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title id="modeti">Add Branch </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form-group">
              <div className="floating-label">
                <input
                  className="form-control"
                  type="text"
                  placeholder=""
                  value={addData.branch_id}
                  onChange={(e) =>
                    setAddData({ ...addData, branch_id: e.target.value })
                  }
                  required
                />
                <label className={addData.branch_id ? "filled" : ""}>
                  Branch Code
                </label>
                {errors.branch_id && (
                  <div className="error-text">{errors.branch_id}</div>
                )}
              </div>

              <div className="floating-label">
                <input
                  className="form-control"
                  type="text"
                  placeholder=""
                  value={addData.branch_name}
                  onChange={(e) =>
                    setAddData({ ...addData, branch_name: e.target.value })
                  }
                  required
                />
                <label className={addData.branch_name ? "filled" : ""}>
                  Branch Name
                </label>
                {errors.branch_name && (
                  <div className="error-text">{errors.branch_name}</div>
                )}
              </div>

              <div className="floating-label">
                <input
                  className="form-control"
                  type="text"
                  placeholder=""
                  value={addData.address}
                  onChange={(e) =>
                    setAddData({ ...addData, address: e.target.value })
                  }
                  required
                />
                <label className={addData.address ? "filled" : ""}>
                  Address
                </label>
              </div>

              <div className="floating-label">
                <input
                  className="form-control"
                  type="tel"
                  placeholder=""
                  value={addData.phone_no}
                  onChange={(e) =>
                    setAddData({ ...addData, phone_no: e.target.value })
                  }
                  required
                />
                <label className={addData.phone_no ? "filled" : ""}>
                  Phone No
                </label>
              </div>

              <div className="floating-label">
                <input
                  className="form-control"
                  type="text"
                  placeholder=""
                  value={addData.email_id}
                  onChange={(e) =>
                    setAddData({ ...addData, email_id: e.target.value })
                  }
                  required
                />
                <label className={addData.email_id ? "filled" : ""}>
                  Email ID
                </label>
              </div>

              {/* Status Select Dropdown */}
              <div className="floating-label">
                <select
                  className="form-control"
                  value={addData.status}
                  placeholder="Select status"
                  onChange={(e) =>
                    setAddData({ ...addData, status: e.target.value })
                  }
                >
                  <option value="">Select Status</option>
                  <option value="Active">Active</option>
                  <option value="InActive">InActive</option>
                </select>
                <label className={addData.status ? "filled" : ""}>
                  Select Status
                </label>
                {errors.status && (
                  <div className="error-text">{errors.status}</div>
                )}
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              className="cancelbut"
              variant="secondary"
              onClick={() => setShowModal(false)}
            >
              Cancel
            </Button>
            <Button
              className="submitbut"
              variant="primary"
              onClick={handlesubmit}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={previewShowModal}
          onHide={() => setpreviewShowModal(false)}
        >
          <Modal.Header closeButton>
            <Modal.Title id="modeti">Preview Branch</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* Other input fields */}

            <div className="form-group">
              <div className="floating-label">
                <input
                  className="form-control"
                  type="text"
                  placeholder=""
                  disabled
                  value={updateData.branch_id}
                  onChange={(e) =>
                    setUpdateData({ ...updateData, branch_id: e.target.value })
                  }
                  required
                />
                <label className={updateData.branch_id ? "filled" : ""}>
                  Branch Code
                </label>
              </div>

              <div className="floating-label">
                <input
                  className="form-control"
                  type="text"
                  placeholder=""
                  disabled
                  value={updateData.branch_name}
                  onChange={(e) =>
                    setUpdateData({
                      ...updateData,
                      branch_name: e.target.value,
                    })
                  }
                  required
                />
                <label className={updateData.branch_name ? "filled" : ""}>
                  Branch Name
                </label>
              </div>

              <div className="floating-label">
                <input
                  className="form-control"
                  type="text"
                  placeholder=""
                  disabled
                  value={updateData.address}
                  onChange={(e) =>
                    setUpdateData({ ...updateData, address: e.target.value })
                  }
                  required
                />
                <label className={updateData.address ? "filled" : ""}>
                  Address
                </label>
              </div>

              <div className="floating-label">
                <input
                  className="form-control"
                  type="tel"
                  placeholder=""
                  disabled
                  value={updateData.phone_no}
                  onChange={(e) =>
                    setUpdateData({ ...updateData, phone_no: e.target.value })
                  }
                  required
                />
                <label className={updateData.phone_no ? "filled" : ""}>
                  Mobile No
                </label>
              </div>

              <div className="floating-label">
                <input
                  className="form-control"
                  type="email"
                  placeholder=""
                  disabled
                  value={updateData.email_id}
                  onChange={(e) =>
                    setUpdateData({ ...updateData, email_id: e.target.value })
                  }
                  required
                />
                <label className={updateData.email_id ? "filled" : ""}>
                  Email ID
                </label>
              </div>

              <div className="floating-label">
                <select
                  className="form-control"
                  value={updateData.status}
                  disabled
                  onChange={(e) =>
                    setUpdateData({ ...updateData, status: e.target.value })
                  }
                >
                  <option value="">Select Status</option>
                  <option value="Active">Active</option>
                  <option value="InActive">InActive</option>
                </select>
                <label className={updateData.status ? "filled" : ""}>
                  Select Status
                </label>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              className="cancelbut"
              variant="secondary"
              onClick={() => setpreviewShowModal(false)}
            >
              Cancel
            </Button>

          </Modal.Footer>
        </Modal>

        {/* ////////////////////////////////////////////// */}
        <Modal
          className="modal"
          show={deleteShowModals}
          onHide={handleCloseModal}
        >
          <Modal.Header>
            <p>Are you sure you want to Delete?</p>
          </Modal.Header>
          <Modal.Body>
            <label className="form-label d-flex">
              <h5 className="mx-1">Branch Name :</h5> <h5>{getdeletename} </h5>
            </label>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="cancelbut"
              variant="secondary"
              onClick={handleCloseModal}
            >
              Close
            </Button>
            <Button
              className="submitbut"
              variant="primary"
              onClick={handleDelete}
            >
              Delete
            </Button>
          </Modal.Footer>
        </Modal>
        {/* _------------------------------pagination button -------------------------------- */}

        <div className="mt-3 pb-5">
          <div className="row">
            <div className="col-lg-7 col-sm-12 mt-1">
              <span className="text-dark">
                Page {currentPage} of {totalPages}
              </span>
            </div>
            <div className="col-lg-5">
              <nav>
                <ul className="pagination justify-content-center">
                  {createPagination()}
                </ul>
              </nav>
            </div>
          </div>
        </div>

        {/* ---------------------------------------end ---------------------------------- */}
      </div>
    </>
  );
}

export default Branch;

